import { BugReportEventType, EndEncounterEventType, FindingEventType, getEncounterEventTypeLabel, InitEncounterEventType, OrderEventType, PathwayEventType, UpdateEncounterEventType, } from '@app/ehr-emulator-shared';
export { BugReportEventType };
export const ENCOUNTER_EVENT_MINUTE_MS = 60 * 1000;
export const getEncounterEventTimelineMs = (event) => event.assignedTimestamp ?? event.__created ?? 0;
export const getEventDisplayLabel = (event) => getEventDescription(event) ?? getEncounterEventTypeLabel(event.eventType);
// `https://console.cloud.google.com/storage/browser/<bucket>/<objectPath>…`
const GCP_STORAGE_BROWSER_RE = /storage\/browser\/([^/]+)\/([^?\s#]+)/;
export const resolveBugReportFileGcsLocation = (file) => {
    const storageBrowserMatch = file.path.trim().match(GCP_STORAGE_BROWSER_RE);
    if (!storageBrowserMatch)
        throw new Error('Bug report file path must be a Google Cloud Console storage browser URL');
    return {
        bucketName: storageBrowserMatch[1],
        objectPath: storageBrowserMatch[2].replace(/\/+$/, ''),
    };
};
export const getEventDescription = (event) => {
    switch (event.eventType) {
        case BugReportEventType:
            return event.description ?? event.title;
        case OrderEventType:
            return event.orderName ?? event.title;
        case PathwayEventType:
            return event.pathwayLabel ?? event.title;
        case FindingEventType:
            return event.findingLabel ?? event.title;
        case EndEncounterEventType:
            return event.title;
        case InitEncounterEventType:
            return event.title;
        case UpdateEncounterEventType:
            return event.title;
        default:
            return event.title;
    }
};
//# sourceMappingURL=encounterEventUtils.js.map